import React, {Component} from 'react';
import {LoaderContainer} from './loader-style';

interface LoaderState {
    active: boolean;
    isSlowProcess?: boolean;
    isLoadingMsg?: string;
}

interface LoaderProps {
  isSlowProcess?: boolean;
  isLoadingMsg?: string;
}

class Loader extends Component<LoaderProps, LoaderState> {

    state: LoaderState = {
        active: true,
        isSlowProcess: this.props.isSlowProcess,
        isLoadingMsg: this.props.isLoadingMsg,
    }

    render() {

    const {active, isSlowProcess, isLoadingMsg} = this.state;

      return (
        <LoaderContainer className={`${(active) ? 'active': ''}`}>
            <div className="loader-holder">
              { isSlowProcess && <p>Este proceso puede tardar varios segundos, espere por favor.</p> }
              { isLoadingMsg && <p>{isLoadingMsg}</p> }
              <div className="spinner"></div>
            </div>
        </LoaderContainer>
      );
    }
  }

export default Loader;